var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-button',{staticClass:"btn",attrs:{"type":"primary"},on:{"click":_vm.push}},[_c('div',{staticStyle:{"margin-top":"2px","float":"left"}},[_c('iconLight')],1),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }